<script lang="ts">
	export let icon_size = 16;
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width={icon_size}
	height={icon_size}
	viewBox="0 0 32 32"
	><path
		fill="currentColor"
		d="M17.74 30L16 29l4-7h6a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h9v2H6a4 4 0 0 1-4-4V8a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4h-4.84Z"
	/><path fill="currentColor" d="M8 10h16v2H8zm0 6h10v2H8z" /></svg
>
